<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index" :class="{'capacity-submenu': item.index === 'capacity-dashboard'}">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem,i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                >{{ threeItem.title }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index" :disabled="subItem.disabled">
                <span class="submenu-title">{{ subItem.title }}</span>
                <span v-if="subItem.badge" class="menu-badge" :class="{'is-pending': subItem.disabled}">{{ subItem.badge }}</span>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from "../common/bus";
export default {
  data() {
    return {
      collapse: false,
      items: [
        {
          icon: 'el-icon-data-analysis',
          index: 'capacity-dashboard',
          title: '美术产能中枢',
          subs: [
            { index: '/capacity_dashboard?report=overview', title: '产能总览' },
            { index: '/capacity_dashboard?report=team', title: '团队分析' },
            { index: '/capacity_dashboard?report=subject', title: '题材分析' },
            { index: '/capacity_dashboard?report=artist', title: '画师分析', badge: '敬请期待', disabled: true },
          ],
        },
        {
          icon: "el-icon-s-cooperation",
          index: "/paint_task_manage",
          title: "关卡任务管理",
        },
        {
          icon: "el-icon-setting",
          title: "配置",
          subs:[
            { index: '/config_project_team', title: '项目组' },
            { index: '/config_subject', title: '题材' },
            { index: '/config_art_team', title: '美术团队' },
            {
              icon: "el-icon-apple",
              index: "/config_cate",
              title: "分类",
            },
          ]
        }
      ],
    };
  },
  computed: {
    onRoutes() {
      if (this.$route.path === '/capacity_dashboard') {
        const report = ['team', 'subject'].includes(this.$route.query.report) ? this.$route.query.report : 'overview';
        return `/capacity_dashboard?report=${report}`;
      }
      return this.$route.path;
    },
  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on("collapse", (msg) => {
      this.collapse = msg;
    });
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 200px;
}
.sidebar > ul {
  height: 100%;
}
.capacity-submenu .el-menu-item {
  display: flex;
  align-items: center;
  padding-right: 16px !important;
}
.capacity-submenu .el-menu-item.is-active {
  color: #fff !important;
  background-color: #20a0ff !important;
}
.capacity-submenu .el-menu-item.is-disabled {
  color: #74869a !important;
  opacity: 1;
}
.submenu-title {
  overflow: hidden;
  text-overflow: ellipsis;
}
.menu-badge {
  flex: none;
  margin-left: auto;
  padding: 0 4px;
  color: #67c23a;
  font-size: 11px;
  line-height: 17px;
  border: 1px solid #67c23a;
  border-radius: 9px;
}
.menu-badge.is-pending {
  color: #909399;
  border-color: #606266;
  background: #354052;
}
</style>
